import FileData, { configureFileDataClasses } from "components/organisms/editor/core/model/lib/file_data/base";
import BinaryFileData from "components/organisms/editor/core/model/lib/file_data/binary_file_data";
import HashFileData from "components/organisms/editor/core/model/lib/file_data/hash_file_data";
import HollowBinaryFileData from "components/organisms/editor/core/model/lib/file_data/hollow_binary_file_data";
import HollowStringFileData from "components/organisms/editor/core/model/lib/file_data/hollow_string_file_data";
import LazyStringFileData from "components/organisms/editor/core/model/lib/file_data/lazy_string_file_data";
import StringFileData from "components/organisms/editor/core/model/lib/file_data/string_file_data";

configureFileDataClasses({
    BinaryFileData,
    HashFileData,
    HollowBinaryFileData,
    HollowStringFileData,
    LazyStringFileData,
    StringFileData,
});

export default FileData;
